module.exports = __webpack_public_path__ + "img/pufeite1.54f87392.png";